// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"261":"47806db6","325":"3d01873d","370":"83de43eb","453":"08c78f33","459":"fbd53eba","713":"7e8dadd2"}[chunkId] + ".chunk.js";
};